import { createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Card, i18n, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';

import { useMst } from '@/mobx-models/Root';
import useWorkOrders, { WorkOrderWithChildren } from '@/rxdb/WorkOrders/useWorkOrders';

import WorkOrderExpansionPanel from '../../WorkOrderExpansionPanel';

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      padding: '16px',
    },
    cardContainer: {
      padding: '16px 0px 0px 0px !important',
    },
  }),
);

const CompleteWorkOrdersCard: React.FC = ({}) => {
  const classes = useStyles();

  const { shiftPicker } = useMst();
  const { listCompleteWorkOrders, workOrdersCollection, workOrdersCollectionsInitialized } =
    useWorkOrders();

  // Complete Work Orders to Display
  const [completeWorkOrders, setCompleteWorkOrders] = useState<WorkOrderWithChildren[]>([]);

  const getCompleteWorkOrders = async () => {
    if (shiftPicker.currentShiftId === null) setCompleteWorkOrders([]);

    try {
      setCompleteWorkOrders(await listCompleteWorkOrders());
    } catch (error) {
      console.log(
        '🚀 ~ file: OtherDeficienciesCard.tsx ~ line 88 ~ getCompleteDeficiencies ~ error',
        error,
      );
    }
  };

  const subscribeToWorkOrderChanges = async () => {
    if (workOrdersCollection) {
      workOrdersCollection.$.subscribe(() => {
        getCompleteWorkOrders();
      });
    }
  };

  useEffect(() => {
    if (workOrdersCollectionsInitialized) {
      getCompleteWorkOrders();
    }

    subscribeToWorkOrderChanges();
  }, [
    workOrdersCollectionsInitialized,
    workOrdersCollection,
    shiftPicker.currentShiftId,
    shiftPicker.selectedShiftEndUTC,
  ]);

  const [expandedId, setExpandedId] = useState<string>();

  const onExpandedPanel = (expanded: boolean, deficiencyId: string) => {
    if (expanded) setExpandedId(deficiencyId);
    else setExpandedId(undefined);
  };

  const getCompleteWorkOrdersCards = () => {
    return completeWorkOrders.map((doc, index) => {
      return (
        <Grid item xs={12} key={`grid-${doc.workOrderDoc.id}`}>
          <WorkOrderExpansionPanel
            workOrder={doc.workOrderDoc}
            equipment={doc.equipmentDoc}
            equipmentType={doc.equipmentTypeDoc}
            index={index}
            expandedWorkOrderId={expandedId}
            onExpanded={onExpandedPanel}
          />
        </Grid>
      );
    });
  };

  return (
    <>
      <Card elevation={1} className={classes.card}>
        <Grid container>
          <Grid item container xs={12}>
            <Grid item xs={10}>
              <Typography variant="h3">{i18n.t('Complete WOs')}</Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12} className={classes.cardContainer}>
            {getCompleteWorkOrdersCards()}
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default observer(CompleteWorkOrdersCard);
